import { SwipeUser, UserLocation } from '../models/api/SwipeUser';
import { rootStore } from '../StApp';
import { DateDetaisBox } from './DateDetailsBox';

export type DateDetailProps = {
    mainImgUrl: string,
    user: SwipeUser,
    likeButton?: boolean 
}

const modalStyle: React.CSSProperties = {
    backgroundColor: '#fff',
    borderRadius: '10px',
    width: '90vw',
    height: '500px',
    position: 'relative',
    overflow: 'scroll'
};

export const DateDetailModal = (props: {
    Modal: React.FC<{
        children: React.ReactNode;
    }>, close: () => void, data: DateDetailProps
}) => {

    const Modal = props.Modal
    const user = props.data.user

    return (
        <Modal>
            <DateDetaisBox user={user} data={props.data} style={modalStyle} ></DateDetaisBox>
        </Modal>
    )

}